<template>
  <div>
    <div><h4 class="text-title xd-text s-20 s-sm-24 w-semi-bold w-sm-medium">ดาวน์โหลดใบเสร็จ</h4></div>
    <b-card class="mt-4 shadow border-0" body-class="p-sm-3 p-2" v-for="item in items" :key="item.id">
      <div class="card-inner-layout">
        <div class="item-card-left">
          <div class="order-detail">
            <div class="text-left">
              <h6 class="order-id-display">
                รายการสั่งซื้อวันที่ {{ getStringDate(item.createdDate) }}
              </h6>
              <div v-for="od in item.saleOrderItem" :key="od.id">
                <span class="item-list"
                  >X{{od.qty}} {{ od.number }} {{ od.product.name }}</span
                ><br />
              </div>
            </div>
            <div class="price-detail"></div>
            <div class=" d-block d-sm-none mt-3">
              <b-button variant="btn btn-warning btn-download" @click="download(item.id)">
                ดาวน์โหลดใบเสร็จ
              </b-button>
            </div>
          </div>
        </div>
        <div class="item-card-right d-none d-sm-block">
          <span class="submit-date">
            <b-button variant="btn btn-warning btn-download" @click="download(item.id)">
              ดาวน์โหลดใบเสร็จ
            </b-button>
          </span>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import axios from "axios";
import { DateTime } from "luxon";
import { ENABLE_RECEIPT } from "../libs/config";
export default {
  components: {},
  data() {
    return {
      items: [],
      enableReceipt: ENABLE_RECEIPT
    };
  },
  methods: {
    download(id) {
      let baseURL = this.axios.defaults.baseURL;
      window.open(baseURL + "/GoodReceive/Reporting?id="+id);
    },
    getStringDate(date) {
      if (!date) return "";
      return DateTime.fromISO(date)
        .reconfigure({ outputCalendar: "buddhist" })
        .setLocale("th")
        .toFormat("d MMMM yyyy");
    }
  },
  mounted() {
    const criteria = {
      UserId: "",
      User: null,
      ContactPrice: 0,
      Fee: 0,
      DiscountPrice: 0,
      DiscountCode: "",
      Status: 5,
      CreatedById: "",
      CreatedBy: null,
      CreatedDate: null,
      UpdatedById: null,
      UpdatedBy: null,
      UpdatedDate: null
    };
    const parent = this.$parent;
    parent.setActiveMenu();

    this.axios.post("/SaleOrder/SearchSaleOrder", criteria).then(response => {
      this.items = response.data.resultData;
    });
  }
};
</script>
<style scoped>
.card-inner-layout {
  display: flex;
  justify-content: space-between;
}

.item-card-left {
  display: flex;
}
.product-img {
  width: 90px;
  height: 135px;
  min-width: 90px;
  min-height: 135px;
  object-fit: cover;
}
.order-detail {
  margin-left: 1rem;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.total-price-detail {
  display: flex;
  align-items: center;
}

.qty-block {
  width: 50px;
  height: 40px;
  background-color: #ecfaf6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-total-price {
  font-size: 1.25em;
  color: red;
}

.item-card-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.status-display {
  display: block;
  color: #ffc107;
}

.submit-date,
.order-id-display {
  display: block;
}

.sm-heading {
  display: none;
  color: gray;
}

.item-list {
  font-size: 14px;
  color: darkgray;
}

.btn-download {
  font-size: 12px;
}
@media (max-width: 767px) {
  .order-detail {
    margin-left: 0;
  }
  /* .item-card {
    padding: 0.75rem 1rem;
  } */

  /* .item-card-right {
    justify-content: center;
  } */

  /* .submit-date,
  .order-id-display {
    display: none;
  }

  .sm-heading {
    display: flex;
    justify-content: space-between;
  }

  .card-inner-layout {
    margin-top: 0.75rem;
  }

  .label-sum {
    display: none;
  } */
}
</style>
